import React, { FC, ReactElement } from 'react';

import UserApplicationPage from 'buyside/components/presentation/UserApplication/userApplicationPage';
import ReCAPTCHAMutationContainer, {
  ReCAPTCHAMutationChildrenProps
} from 'buyside/components/container/MutationContainers/ReCAPTCHA/ReCAPTCHAMutationContainer';

import { initialValues } from 'buyside/components/presentation/UserApplication/Helpers/userApplicationPageConstants';

import { ApplicantTypes, ApplicationFormValues } from 'interfaces/userApplication/userApplication';

import { useCreateOrUpdateUserApplicationMutation } from 'interfaces/graphql-typings';

const UserApplicationPageContainer: FC<{
  existingApplication?: ApplicationFormValues | null;
  email?: string;
  firstName?: string;
  lastName?: string;
}> = ({ existingApplication, email, firstName, lastName }): ReactElement => {
  const [createOrUpdateUserApplication, { loading }] = useCreateOrUpdateUserApplicationMutation();

  const applicantType = existingApplication?.applicantType
    ? existingApplication.applicantType === 'pro'
      ? ApplicantTypes.pro
      : ApplicantTypes.basic
    : null;

  return (
    <ReCAPTCHAMutationContainer pageName="the user application" action="UserApplication">
      {({ grecaptcha }: ReCAPTCHAMutationChildrenProps): ReactElement => (
        <UserApplicationPage
          applicantType={applicantType}
          createOrUpdateUserApplication={createOrUpdateUserApplication}
          grecaptcha={grecaptcha}
          initialPage={existingApplication ? 2 : 0}
          initialValues={existingApplication || { ...initialValues, email, firstName, lastName }}
          isLoading={loading}
        />
      )}
    </ReCAPTCHAMutationContainer>
  );
};

export default UserApplicationPageContainer;
